"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const style_module_css_1 = __importDefault(require("./style.module.css"));
function Spinner({ color = '#7f58af', className, style }) {
    const circles = [...Array(12)].map((_, index) => {
        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(style_module_css_1.default['div-after']), style: { background: color } }) }, index));
    });
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(style_module_css_1.default['lds-spinner'], className), style: { ...style }, children: circles }));
}
exports.Spinner = Spinner;
//# sourceMappingURL=spinner.js.map